import React, { useState, useEffect } from "react";

import Interweave from "interweave";

import { AxiosInstance } from "../../utilities";
import FeaturedActsComponent from "./FeaturedActsComponent/FeaturedActsComponent";
import PromoSongsComponent from "./PromoSongsComponent/PromoSongsComponent";
import styles from "./TalentComponent.module.css";

export default function TalentComponent(props) {
  const [featuredActList, setFeaturedActList] = useState([]);
  const [promoVideosList, setPromoVideosList] = useState([]);

  const { content } = props;

  useEffect(() => {
    fetchPromoVideos();
    fetchFeaturedActs();
  }, []);

  //2025-11-14: https://starlightmusicnyc.slack.com/archives/C03UZF6RG05/p1763066657486439 
  //Evan asked to remove Starlight Orchestra from the list
  const removableBands = ["Starlight Orchestra"]

  const fetchPromoVideos = () => {
    AxiosInstance(4008, "application/json")
      .get("/ourTalent/promoVideos")
      .then((resp) => {
        const response = resp && resp.data;
        if (
          response &&
          (response.status === 200 || response.status === "200")
        ) {
          const responseData = response.data
          
          if(removableBands.length && responseData?.length){
            const filteredData = responseData.filter((item) => !removableBands.includes(item?.name));
            setPromoVideosList(filteredData);
          }else{
            setPromoVideosList(responseData);
          }
        }
      })
      .catch((err) => console.log(err));
  };

  const fetchFeaturedActs = () => {
    AxiosInstance(4008, "application/json")
      .get("/ourTalent/bands")
      .then((resp) => {
        const response = resp && resp.data;
        if (
          response &&
          (response.status === 200 || response.status === "200")
        ) {
          const responseData = response.data
          
          if(removableBands.length && responseData?.length){
            const filteredData = responseData.filter((item) => !removableBands.includes(item?.name));
            setFeaturedActList(filteredData);
          }else{
            setFeaturedActList(responseData);
          }
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <section className={`${styles.our_talent_container} fixed-nav`}>
      <div className={styles.our_talent_container_bg}></div>
      <img
        src="/assets/images/result_map.svg"
        alt="map-imag"
        className={styles.result_map}
      />
      <img
        src="/assets/images/result_design.svg"
        alt="map-imag-deisgn"
        className={styles.result_design}
      />
      <div className="container-fluid">
        <div className={styles.our_talent_header}>
          <h1 className={`${styles.our_talent_heading} text-center `}>
            {content?.heading?.value}
          </h1>
            <Interweave
              tagName="h3"
              allowElements={false}
              content={content?.sub_heading?.value}
              className={`${styles.our_talent_msg} text-center `}
            />
        </div>
        <PromoSongsComponent data={promoVideosList} />
        <FeaturedActsComponent props={props} data={featuredActList} />
      </div>
    </section>
  );
}
